<template lang="pug">
  .home-ctas-vue
    template(v-if="hasColorBar") 
      .cta-titles.text-center
        p.xs-f-xxlarge.sm-f-xxlarge.md-f-xlarge.lg-f-xxxlarge.max-at-tweak Your place or ours?
        p.xs-f-xmedium.sm-f-xmedium.md-f-medium.lg-f-xmedium.max-at-tweak delivered to your door 
          span + Color Bar locations
  
      .dual-ctas.text-center
        a.primary-cta.primary-cta-subtitle(href="/shop/hair-color" aria-label="Color Advisor")
          p.xs-f-large.sm-f-xlarge.md-f-xlarge.lg-f-xxlarge.max-at-tweak At home 
          span.thin.xs-f-medium.sm-f-medium.md-f-small.lg-f-medium.max-at-tweak Find your perfect shade
            i.icon-arrow-forward.xs-f-xlarge.sm-f-xlarge.md-f-large.lg-f-xlarge.max-at-tweak
              span.ada-tooltip arrow forward icon
  
        a.primary-cta.primary-cta-subtitle(href="/colorbar/locations" aria-label="Color Bar Locations")
          p.xs-f-large.sm-f-xlarge.md-f-xlarge.lg-f-xxlarge.max-at-tweak locations 
          span.thin.xs-f-medium.sm-f-medium.md-f-small.lg-f-medium.max-at-tweak  Book an appointment
            i.icon-arrow-forward.xs-f-xlarge.sm-f-xlarge.md-f-large.lg-f-xlarge.max-at-tweak
              span.ada-tooltip arrow forward icon
  
    template(v-else)
      .single-cta.text-center
        a.mr-btn.xs-f-xsmall.md-f-small.max-at-tweak(href="/shop/hair-color" aria-lable="Color Advisor") Find your perfect shade 

</template>

<script>
  import { mapActions, mapState } from 'vuex';

  export default {
    name: "HomeCtas",

    inject: ['getObjProperty'],

    computed: {
      ...mapState('colorAdvisor', ['answers', 'answersUpdated']),

      hasColorBar() {
        return !!this.getObjProperty(this.answers, 'near_colorbar');
      }
    },

    methods: {
      ...mapActions('colorAdvisor', ['initAnswers']),
    },

    mounted() {
      if(this.answersUpdated === 0) {
        this.initAnswers();
      }
    }
  }
</script>

<style scoped lang="stylus">
  .home-ctas-vue
    padding 4em 0
    margin 0 5%  
    border-top 1px solid color-fog-light
    .single-cta
      .primary-cta
        border-radius 0 !important

    .dual-ctas
      display flex
      flex-direction column
      justify-content center
      .primary-cta
        display inline-block

      .primary-cta:first-child
        margin-right 3em

    .cta-titles
      margin 0 auto 4em auto

      p:first-of-type
        letter-spacing 2px
        font-weight 600
        text-transform uppercase

      p:nth-of-type(2)
        letter-spacing 0
        color #55565a

    .primary-cta
      width 18em
      height 3.8em
      border-radius 8px
      color #ffffff
      padding 1.1em
      margin 0 auto
      background-color #53284f
      transition background-color 0.2s

      &:hover
        cursor pointer
        background-color #803379

      p
        font-weight 800
        text-transform uppercase

      span
        position relative
        font-weight 600
        text-transform none

        i
          position absolute
          line-height 1
          right -1.5em

      &.primary-cta-subtitle
        width 32em
        height 7.5em
        padding 1.2em
  
    @media mq-desktop-md
      .dual-ctas
        .primary-cta:first-child
          margin-right 1.5em

      .primary-cta
        &.primary-cta-subtitle
          width 26em
          height 7em

    @media mq-tablet-less
      .dual-ctas
        .primary-cta
          display block
          margin 1em auto

        .primary-cta:first-child
          margin-right auto
      .primary-cta
        width 90%
        height 4em
        padding 1.3em 0.9em

        &.primary-cta-subtitle
          width 90%
          height 6em

      .cta-titles
        margin-bottom 2em

        p:first-of-type
          margin-bottom 1em

        p:nth-of-type(2)
          span
            display block

    @media mq-tablet
      .primary-cta
        width 70%

        &.primary-cta-subtitle
          width 70%

    @media (min-width 400px) and (max-width 759px)
      .primary-cta
        &.primary-cta-subtitle
          padding 0.7em

    @media (min-width 760px)
      .dual-ctas
        flex-direction row

</style>
